import { ArtistCategory, Model } from '@favid-inc/api';
import { StateUtils } from 'utils';

const ARTIST_CATEGORIES = 'ArtistCategories';
const tag = StateUtils.actionType(ARTIST_CATEGORIES);

export const BEFORE_PROCESSING = tag`BEFORE_PROCESSING`;
export const ON_FETCH_CATEGORIES = tag`ON_FETCH_CATEGORIES`;
export const ON_UPDATE_CATEGORIE = tag`ON_UPDATE_CATEGORIE`;
export const ERROR_FETCH_CATEGORIES = tag`ERROR_FETCH_CATEGORIES`;

export interface Categorie extends Model {
    description: ArtistCategory;
  }
